import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AssessmentsService } from '../../shared/services/assessments.service';
import { Configuration } from '../../app.constants';

@Component({
  selector: 'app-print-plans',
  templateUrl: './print-plans.component.html',
  styleUrls: ['./print-plans.component.css']
})
export class PrintPlansComponent implements OnInit {
  assocId = '';
  assocName = '';
  assocGroupId = '';
  currentTab = 'talent';
  answers = [];
  talentQuestions = {};
  skillQuestions = {};
  digitalQuestions = {};
  talentAnswers = {};
  skillAnswers = {};
  digitalAnswers = {};
  answerHelpPopup = [];
  isPlanned = true;
  successorValues = {
    departureRiskLevel: '',
    remakrs: '',
    successors: [],
    reasonForLeaving: '',
    businessImpactDeparture: '',
    retentionAction: ''
};
  developmentValues = [];
  associatList = [];
  myPurpose = 'validation'; // to make values uneditable // because code was copied from assessment component
  selectedAssessId = 2018;
  fullResponse: any = false;
  isHistoryViewable = false;
  assessments = [];
  isNewEmployee = false;
  public serverApiUrl;

  constructor( public route: ActivatedRoute,
    public config: Configuration,
    private AssessmentsServiceObj: AssessmentsService) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.assocId = params['assocId'];
      this.selectedAssessId = params['assessmentId'];
      this.getAssessData(this.selectedAssessId);
      
  });
    this.serverApiUrl = this.config.StaticImageUrl;
    // this.route.params.subscribe(params => {
    //     this.assocId = params['id'];
    //     this.AssessmentsServiceObj.getAssessHistoryIds(this.assocId).then(assessments => {
    //       this.assessments = assessments['assess'];
    //       this.getDefaultAssessment();
    //     }).catch(err => {
    //       console.log(err);
    //     });
    // });
  }

  yearChanged() {
    console.log('jere');
    if (this.isAssessAssessed(this.selectedAssessId)) {
      this.getAssessData(this.selectedAssessId);
      this.isHistoryViewable = true;
    } else {
      this.isHistoryViewable = false;
    }
  }

  getDefaultAssessment() {
    if (this.assessments.length) {
      this.selectedAssessId = this.assessments[this.assessments.length - 1].assessmentId;
      if (this.isAssessAssessed(this.selectedAssessId)) {
        this.getAssessData(this.selectedAssessId);
        this.isHistoryViewable = true;
      } else {
        this.isHistoryViewable = false;
      }
    } else {
      this.isHistoryViewable = false;
    }
  }

  isAssessAssessed(assessId) {
    for (let i = 0 ; i < this.assessments.length ; i++ ) {
      if (this.assessments[i].assessmentId === assessId) {
        if (this.assessments[i].line.isPlanned &&
          this.assessments[i].line.isAssessed &&
          this.assessments[i].line.isLeadershipDone) {
            return true;
        } else {
          return false;
        }
      }
    }
    return false;
  }

  getAssessData(assessId = null) {

    this.answers = [];
    this.talentQuestions = {};
    this.skillQuestions = {};
    this.digitalQuestions = {};
    this.talentAnswers = {};
    this.skillAnswers = {};
    this.digitalAnswers = {};
    this.answerHelpPopup = [];
    this.successorValues = {
      departureRiskLevel: '',
      successors: [],
    remakrs: '',
    reasonForLeaving: '',
    businessImpactDeparture: '',
    retentionAction: ''
    };
    this.developmentValues = [];
    this.associatList = [];
    this.AssessmentsServiceObj.getAssessQuestionsPublic(this.assocId, assessId).then(response => {
      this.fullResponse = response;
      var oneDay = 24*60*60*1000; // hours*minutes*seconds*milliseconds
      var firstDate = new Date(this.fullResponse['assoc'].jobDescription.jobStartDate);
        var secondDate = new Date();
        var diffDays = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime())/(oneDay)));
        if(diffDays < 183){
          this.isNewEmployee = true;
        }
      this.assocName = response['assoc']['personalInformation']['fullName'];
      this.assocGroupId = response['assoc']['groupId'];
      this.updateAnswers(response['answers']);
      this.talentQuestions = {};
      this.digitalQuestions = {};
      this.skillQuestions = {};
      this.makeQuestionsObj(response['questions'], response['answers'], 'Talent Assessment');
      this.makeQuestionsObj(response['questions'], response['answers'], 'Skill Assessment');
      this.makeQuestionsObj(response['questions'], response['answers'], 'Digital Assessment');
      if (response && response['answers'] && response['answers'][0]['line'] && response['answers'][0]['line']['successor']) {
        this.successorValues = response['answers'][0]['line']['successor'];
      }
      if (response && response['answers'] && response['answers'][0]['line'] && response['answers'][0]['line']['development']) {
        this.developmentValues = response['answers'][0]['line']['development'];
      }
      for(let i=0 ; i<response['answers'][0].higherManagers.length ; i++) {
        if(response['answers'][0].higherManagers[i].isPlanned && response['answers'][0].higherManagers[i].isLeadershipDone){
          this.developmentValues = response['answers'][0].higherManagers[i].development;
          this.successorValues = response['answers'][0].higherManagers[i].successor;
        }
      }
    }).catch(err => {
      console.log(err);
    });
  }

  updateAnswers(answers) {
    if (answers && answers[0] && answers[0]['line']['skillAssess'] && answers[0]['line']['skillAssess']['answers']) {
      answers[0]['line']['skillAssess']['answers'].forEach(indAnswer => {
        this.skillAnswers[indAnswer.questionId.toString()] = indAnswer.answer;
      });
    }
    if (answers && answers[0] && answers[0]['line']['talentAssess'] && answers[0]['line']['talentAssess']['answers']) {
      answers[0]['line']['talentAssess']['answers'].forEach(indAnswer => {
        this.talentAnswers[indAnswer.questionId.toString()] = indAnswer.answer;
      });
    }
    if (answers && answers[0] && answers[0]['line']['digitalAssess'] && answers[0]['line']['digitalAssess']['answers']) {
      answers[0]['line']['digitalAssess']['answers'].forEach(indAnswer => {
        this.digitalAnswers[indAnswer.questionId.toString()] = indAnswer.answer;
      });
    }
  }

  makeQuestionsObj(questions, answers, type) {
    let myObj;
    let questionNumber = 1;
    if (type === 'Talent Assessment') {
      myObj = this.talentQuestions;
    } else if (type === 'Skill Assessment') {
      myObj = this.skillQuestions;
    } else if (type === 'Digital Assessment') {
      myObj = this.digitalQuestions;
    }
    questions.forEach(question => {
      if (question.category === type) {
        // console.log(question.category + ' --- ' + type);
        if (question.topic1.trim() && !myObj[question.topic1.trim()]) {
          myObj[question.topic1.trim()] = [];
        }
        if (question.topic2.trim() && !myObj[question.topic1.trim()][question.topic2.trim()]) {
          myObj[question.topic1.trim()][question.topic2.trim()] = [];
        }
        if (question.topic3.trim() && !myObj[question.topic1.trim()][question.topic2.trim()][question.topic3.trim()]) {
          myObj[question.topic1.trim()][question.topic2.trim()][question.topic3.trim()] = [];
        }
        let objToUpdate = myObj[question.topic1.trim()];
        if (question.topic2) {
          objToUpdate = myObj[question.topic1.trim()][question.topic2.trim()];
        }
        if (question.topic3) {
          objToUpdate = myObj[question.topic1.trim()][question.topic2.trim()][question.topic3.trim()];
        }
        try {
          objToUpdate.push({
            questionId: question._id.toString(),
            question: question.question,
            questionNumber: questionNumber++,
            ansDetails: question.ansDetails,
            ansOptions: question.ansOptions
          });
        } catch (err) {
          console.log(question);
        }
      }
    });
  }

  getKeys(obj) {
    return Object.keys(obj);
  }

  isInt(value) {
    return !isNaN(value) && !isNaN(parseInt(value, 10));
  }

  showDetails(details) {
    this.answerHelpPopup = [];
    details.forEach(indDet => {
      this.answerHelpPopup.push(indDet.desc.replace('||||', ''));
    });
  }
}
